import React from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { DISPLAY_DEVICE_CREATION } from "featureSwitches/flagsList";
import { ButtonLink } from "components/MUIExtensions/ButtonLink";
import { CONFIGURE_IR } from "routers/routePaths";

const FRAME_DATA = {
  imgSrc: "/static/img/solutions/automate-ac.png",
  imgAlt:
    "Um aparelho de ar condicionado sendo controlado por aplicativo em um telefone celular",
  title: "Automação de Ar-condicionado",
  buttonText: "Ir para a Loja Virtual",
  customUrl:
    "https://www.enermatch.com/checkouts/controle-universal-infravermelho/",
  cardImgSrc:
    "https://www.enermatch.com/wp-content/uploads/2024/11/infra-vermelho-01.jpg",
};

export const AutomateAC = ({ history }) => {
  const displayV2 = DISPLAY_DEVICE_CREATION.getValue();
  const handleClick = () => {
    history.push("/frames/store");
  };

  const handleCardClick = () => {
    history.push("/frames/store", { customUrl: FRAME_DATA.customUrl });
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleClick}>
      <BlockStandard hideDivider={!displayV2}>
        <Typography variant="h2">Excelente iniciativa!</Typography>
        <Typography variant={displayV2 ? "body2" : "body1"}>
          Evitar o desperdício de energia é fundamental para reduzir custos e
          descarbonizar.
        </Typography>
        {!displayV2 && (
          <Typography>
            Adquira um infra-vermelho para automatizar cada ambiente climatizado
            com ar-condicionados split ou cassete.
          </Typography>
        )}

        {displayV2 && (
          <ButtonLink to={CONFIGURE_IR} variant="contained">
            Configurar dipositivo IoT
          </ButtonLink>
        )}
      </BlockStandard>

      <BlockStandard hideDivider>
        <Typography variant="h2">Potencial de economia: até 25%</Typography>
        <Card sx={{ display: "flex" }}>
          <CardActionArea sx={{ display: "flex" }} onClick={handleCardClick}>
            <CardMedia
              sx={{ flex: 1, height: "100%" }}
              image={FRAME_DATA.cardImgSrc}
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2">
                Controle Remoto Inteligente Un. Infra
              </Typography>
              <Typography>A partir de:</Typography>
              <Typography variant="body2">R$ 149,00</Typography>
            </CardContent>
          </CardActionArea>
        </Card>

        {displayV2 && (
          <Typography variant="body2">
            Adquira um infra-vermelho para automatizar cada ambiente climatizado
            com ar-condicionados split ou cassete.
          </Typography>
        )}
      </BlockStandard>
    </SolutionsFrame>
  );
};
